import type { Activity } from '@/modules/documents/domain/entities/activity';

import { WhatsNewLink } from '../whats-new-link';

type ActivityNewsProps = {
  activity: Activity;
};

export function ActivityNews({ activity }: ActivityNewsProps) {
  const path =
    activity.siteIds.length > 0
      ? `/asset/${activity.siteIds[0]}/documents?id=${encodeURIComponent(activity.document.id)}`
      : `/documents?id=${encodeURIComponent(activity.document.id) || ''}`;

  return <WhatsNewLink to={path}>{activity.document.name}</WhatsNewLink>;
}
